import Link from 'next/link';

import { Button, ButtonProps } from '@dansk-metal/ui';

import { EventDto } from '@web/services/crm-api/rest';

import styles from './event-registration-confirmation.module.scss';

type RegistrationConfirmationProps = {
	onClose: ButtonProps['onClick'];
	event: EventDto;
	userEventsUrl: string;
};

export function RegistrationConfirmation({ onClose, event, userEventsUrl }: RegistrationConfirmationProps) {
	return (
		<div className={styles.container}>
			<div className={styles.head}>
				<h2>Tilmelding</h2>
			</div>

			<div className={styles.block}>
				<h3>Du er nu tilmeldt</h3>

				<p>
					Tak for din tilmelding til "{event.title}".
					<br />
					Du modtager en email som bekræftelse på din tilmelding og du kan altid se dine
					tilmeldte arrangementer på din medlemsside under <strong><Link href={userEventsUrl}>arrangementer</Link></strong>.
				</p>
			</div>

			<div className={styles.block}>
				<div>
					<div className={styles.button}>
						<Button icon={{ icon: 'arrow-right', size: 24 }} onClick={onClose}>
							Luk
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
